import { render, staticRenderFns } from "./modalEditSocialLevel.vue?vue&type=template&id=4b0e3346&"
import script from "./modalEditSocialLevel.vue?vue&type=script&lang=js&"
export * from "./modalEditSocialLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports